/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 08/05/2021
 *
 * @version 0.2
 * Revisions:
 * 08/05/2021 - BW - Initial Creation
 * 04/05/2022 - BW - Modified: processCaseMenuCounts - added code for Payment
 *
 * Description/Purpose:
 * Case Menu Count
 ************************************************************** */
import { COMMON as CASE_MENU_COMMON } from "util/case-menu-util";


const COMMON = {
  E_ACT_CASE_MENU_COUNT_SELECTOR: '#e_act_case_menu_count',
  RUN_CASE_MENU_COUNT_SELECTOR: '#run_case_menu_count',
};

const COMMON_TAG_DATA = {
  E_ACT_CASE_MENU_COUNT: $(COMMON.E_ACT_CASE_MENU_COUNT_SELECTOR).val(),
  RUN_CASE_MENU_COUNT: $(COMMON.RUN_CASE_MENU_COUNT_SELECTOR).val() === 'true',
};

const CaseMenuCountUtil = {


  /**
     * Process the data
     * @param caseMenuCountJsonDto
     */
  processCaseMenuCounts(caseMenuCountJsonDto) {
    this.updateText($(CASE_MENU_COMMON.CASE_CALENDAR_SELECTOR), caseMenuCountJsonDto.caseCalendarCount);
    this.updateText($(CASE_MENU_COMMON.CATEGORY_VIEW_SELECTOR), caseMenuCountJsonDto.categoryViewCount);
    this.updateText($(CASE_MENU_COMMON.DATE_VIEW_SELECTOR), caseMenuCountJsonDto.dateViewCount);
    this.updateText($(CASE_MENU_COMMON.DEPOSITION_VIEW_SELECTOR), caseMenuCountJsonDto.depositionViewCount);
    this.updateText($(CASE_MENU_COMMON.DOCUMENT_PRODUCTION_VIEW_SELECTOR),
      caseMenuCountJsonDto.documentProductionViewCount);
    this.updateText($(CASE_MENU_COMMON.FILE_EXPORT_SELECTOR), caseMenuCountJsonDto.fileExportCount);
    this.updateText($(CASE_MENU_COMMON.FORM_SELECTOR), caseMenuCountJsonDto.formCount);
    this.updateText($(CASE_MENU_COMMON.HEARING_VIEW_SELECTOR), caseMenuCountJsonDto.hearingViewCount);
    this.updateText($(CASE_MENU_COMMON.MASTER_CALENDAR_SELECTOR), caseMenuCountJsonDto.masterCalendarCount);
    this.updateText($(CASE_MENU_COMMON.MESSAGE_BOARD_SELECTOR), caseMenuCountJsonDto.messageBoardCount);
    this.updateText($(CASE_MENU_COMMON.PERSONAL_CALENDAR_SELECTOR), caseMenuCountJsonDto.personalCalendarCount);
    this.updateText($(CASE_MENU_COMMON.PAYMENT_SELECTOR), caseMenuCountJsonDto.outstandingAmount);
  },

  /**
     * Updates the
     * @param $elem
     * @param count
     * @param showZero
     * @returns {boolean}
     */
  updateText($elem, count, showZero = true) {
    if (count !== null && count !== undefined && count.length > 0) {
      const isZeroValue = parseInt(count) === 0;
      if (!showZero && isZeroValue) return false;
      const text = $elem.text();
      $elem.html(`${text} <span class='case-menu-count'>(${count})</span>`);
    }
  },

};

export {
  CaseMenuCountUtil, COMMON, COMMON_TAG_DATA,
};
